import { useTheme } from '@material-ui/core'
import { createStyles } from '@material-ui/core/styles'
import { Theme } from '@material-ui/core/styles'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import React, { ReactNode, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export interface IProps {
  fullPage?: boolean
  onClose: (evt: any) => void
  buttons: ReactNode
  buttonBarHeight?: string | number
  children: ReactNode
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonBar: {
      backgroundColor: theme.modal.buttonBarColor,
    },
  })
)

const MobileModal = (props: IProps) => {
  const classes = useStyles()
  const { t: tui } = useTranslation('UI', {
    useSuspense: false,
  })

  const html: HTMLElement = document.querySelector('html')
  const body: HTMLBodyElement = document.querySelector('body')

  useEffect(() => {
    html.classList.add('material-chooser-visible')
    body.classList.add('material-chooser-visible')

    return function onUnmount() {
      html.classList.remove('material-chooser-visible')
      body.classList.remove('material-chooser-visible')
    }
  }, [])

  return (
    <div
      className={clsx('material-chooser', {
        ['material-chooser--fullPage']: props.fullPage,
      })}
    >
      <div className={'cancel-button'}>
        <button
          className={clsx('material-icons mdc-icon-button')}
          aria-label={tui('close-modal-button')}
          title={tui('close-modal-button')}
          aria-pressed="false"
          onClick={props.onClose}
          data-upload-artwork-element={'close-uploader'}
        >
          cancel
        </button>
      </div>
      <div className="material-chooser-wrap">{props.children}</div>
      <div
        className={clsx(
          'material-chooser-buttons si-text-centered si-row',
          classes.buttonBar
        )}
        style={{ height: props.buttonBarHeight }}
      >
        {props.buttons}
      </div>
    </div>
  )
}

export default MobileModal
